import axios from "../../utils/Axios";

export const getSingleJob = async (id) => {
    const response = await axios.get(`/jobs/${id}`);
    return response.data;
}